import React, { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { getAuthHeader } from '../utils/auth'; // ★ 1. 認証ヘッダー取得関数をインポート
import {
    ENGLISH_BETA_LEGAL_SUMMARY_URL,
    ENGLISH_BETA_PRIVACY_URL,
    ENGLISH_BETA_SCTA_URL,
    ENGLISH_BETA_TERMS_URL,
    JAPAN_GTM_ASSISTANT_URL,
    SALESBREAKER_ENGLISH_GUIDE_URL,
    isEnglishOperatorMode,
} from "../utils/operatorMode";

// --- SVG Icons ---
const ManualIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" /></svg>;
const AdviceIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const FaqIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const VideoIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-3 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /><path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;
const LightbulbIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" /></svg>;
const PartnershipIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M12 8c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm0 2c-2.21 0-4 1.79-4 4v1h8v-1c0-2.21-1.79-4-4-4zm6 4h-2v-1c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v1H4v-1c0-2.21 1.79-4 4-4h8c2.21 0 4 1.79 4 4v1z" /></svg>;
const BrainIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M4.874 15.352c-2.493-2.493-2.493-6.53 0-9.023s6.53-2.493 9.023 0c1.782 1.782 2.18 4.293 1.22 6.516M19.126 8.648c2.493 2.493 2.493 6.53 0 9.023s-6.53 2.493-9.023 0c-1.782-1.782-2.18-4.293-1.22-6.516M12 21a9 9 0 007.874-13.352M12 3a9 9 0 00-7.874 13.352" /></svg>;
const PartnerProgramIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-3 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.653-.134-1.276-.38-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.653.134-1.276.38-1.857m0 0A2.25 2.25 0 0112 13.5a2.25 2.25 0 012.62 1.643M12 13.5V9m0 4.5V9m0 4.5a2.25 2.25 0 00-2.62 1.643m2.62-1.643a2.25 2.25 0 012.62 1.643M12 9a2.25 2.25 0 012.25-2.25A2.25 2.25 0 0116.5 9m-4.5 0A2.25 2.25 0 009.75 6.75 2.25 2.25 0 007.5 9m4.5 0V6.75" /></svg>;


const API_URL = "https://salesbreaker.jp";

const tutorialVideos = [
    { id: 'JtVcegUD9Vc', title: '【チュートリアル動画①】会社概要編', description: 'Sales Breakerの基本的な情報を設定する方法について解説しています。' },
    { id: 'qmTSZ4boJ90', title: '【チュートリアル動画②】NG設定&送信除外設定編', description: '特定のキーワードやドメインを送信対象から除外する設定方法を解説しています。' },
    { id: 'ecjhtxdt_zA', title: '【チュートリアル動画③】文章作成編', description: 'フォームに自動入力する文章のテンプレート作成方法を、差し込みタグの活用法も交えて解説しています。' },
    { id: '2a2dK-R3mgo', title: '【チュートリアル動画④】送信編', description: '作成した文章を使い、業種や地域でターゲットを絞って実際に送信するまでの一連の流れを解説しています。' },
    { id: 'pEWxBF0PWcE', title: '【新機能】マイリスト管理', description: '特定の条件で絞り込んだ営業リストを保存し、後から簡単に呼び出して送信キャンペーンに利用する方法を解説します。' },
    { id: '2-3sWjhYjpk', title: '【チュートリアル動画⑤】案件管理編', description: '案件のステータス管理や担当者の割り当てなど、営業プロセスを可視化・効率化する方法を解説します。' },
    { id: '9WnHYnxbA7Y', title: '【チュートリアル動画⑥】その他編', description: 'アカウント情報の変更、ユーザーの追加・管理方法など、知っておくと便利な機能について解説します。' },
];

const VideoCard = ({ videoId, title, description }) => (
    <div className="bg-slate-50 rounded-lg overflow-hidden border border-slate-200 shadow-sm hover:shadow-lg transition-shadow">
        <div className="aspect-video">
            <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${videoId}`}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
            ></iframe>
        </div>
        <div className="p-4">
            <h4 className="font-bold text-slate-800">{title}</h4>
            <p className="text-sm text-slate-600 mt-1">{description}</p>
        </div>
    </div>
);

const EnglishOperatorHelpSurface = ({ inquiryType, setInquiryType, subject, setSubject, isSubmitting, handleFormSubmit }) => {
    const glossary = [
        ["Execution Lane", "Concurrent execution capacity. A lane is not a target count."],
        ["Start Outreach", "Operator-approved action that queues governed outreach into Japanese companies."],
        ["Execution History", "Outcome log for submitted, needs review, not eligible, failed, or suppressed targets."],
        ["Engagement Events", "Click and visit signals used for follow-up prioritization."],
        ["Suppression", "Company/domain exclusion and opt-out protection before execution."],
        ["JST", "Japan Standard Time. English beta execution timestamps stay Japan-specific."],
    ];
    const faq = [
        ["Why is company data still Japanese?", "SalesBreaker preserves Japanese company names, addresses, industries, tags, and source records in their original format so operators work from Japan-native data instead of lossy translations."],
        ["What is an Execution Lane?", "An Execution Lane is concurrent execution capacity for governed outreach. It is infrastructure capacity, not an unlimited blast count."],
        ["Why might I receive many replies or contact-form notifications?", "Japan-facing outreach can generate reply emails, thank-you emails, and contact-form notifications. We recommend using a dedicated inbox separate from your primary business email."],
        ["What happens after the 3-day trial?", "English Operator Beta is paid-only. A payment method is required, and the selected plan starts automatically unless canceled before the trial ends."],
        ["Why are some outreach results still Japanese?", "Outreach copy and certain company-source fields remain Japanese because the execution target is Japanese companies and Japanese forms."],
        ["Does SalesBreaker translate or execute outreach automatically?", "No. The English beta helps operators understand and approve Japan GTM execution. GPTs support drafting and guidance; they do not execute outreach."],
    ];

    return (
        <div className="p-4 md:p-8 bg-gray-50 min-h-full">
            <div className="container mx-auto px-4 sm:px-6 max-w-6xl">
                <div className="rounded-2xl bg-slate-950 p-8 text-white shadow-xl">
                    <p className="text-xs font-black uppercase tracking-[0.22em] text-cyan-200">English Operator Beta</p>
                    <h1 className="mt-3 text-3xl sm:text-4xl font-black tracking-tight">Help & Support</h1>
                    <p className="mt-4 max-w-3xl text-slate-300 leading-7">
                        Operate Japan-facing outreach from the SalesBreaker control plane. Targets, outreach copy, form conventions, and timestamps remain Japan-specific.
                    </p>
                    <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                        <a href={SALESBREAKER_ENGLISH_GUIDE_URL} target="_blank" rel="noopener noreferrer" className="rounded-xl bg-cyan-300 px-5 py-3 text-center text-sm font-black text-slate-950 hover:bg-cyan-200">
                            Open SalesBreaker English Guide
                        </a>
                        <a href={JAPAN_GTM_ASSISTANT_URL} target="_blank" rel="noopener noreferrer" className="rounded-xl border border-white/15 px-5 py-3 text-center text-sm font-black text-white hover:bg-white/10">
                            Open Japan GTM Assistant
                        </a>
                    </div>
                </div>

                <div className="mt-10 grid gap-5 md:grid-cols-2">
                    {glossary.map(([term, description]) => (
                        <div key={term} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                            <h2 className="text-lg font-black text-slate-900">{term}</h2>
                            <p className="mt-2 text-sm leading-6 text-slate-600">{description}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-10 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    <h2 className="text-2xl font-black text-slate-900">Operator workflow</h2>
                    <div className="mt-5 grid gap-4 md:grid-cols-4">
                        {[
                            ["1", "Set Company Profile & Suppression"],
                            ["2", "Create Japanese outreach template"],
                            ["3", "Review target filters and preview"],
                            ["4", "Start governed outreach and monitor outcomes"],
                        ].map(([step, text]) => (
                            <div key={step} className="rounded-xl bg-slate-50 p-4">
                                <div className="text-xs font-black uppercase tracking-widest text-indigo-600">Step {step}</div>
                                <p className="mt-2 text-sm font-bold text-slate-800">{text}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-10 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    <h2 className="text-2xl font-black text-slate-900">Japanese outreach culture support</h2>
                    <p className="mt-3 text-sm leading-6 text-slate-600">
                        Use Japan GTM Assistant to review tone, first-contact etiquette, honorifics, form-specific phrasing, and company context. The assistant supports the operator; it does not execute outreach.
                    </p>
                </div>

                <div className="mt-10 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    <h2 className="text-2xl font-black text-slate-900">English beta FAQ</h2>
                    <div className="mt-5 grid gap-4 md:grid-cols-2">
                        {faq.map(([question, answer]) => (
                            <div key={question} className="rounded-xl bg-slate-50 p-4">
                                <h3 className="text-sm font-black text-slate-900">{question}</h3>
                                <p className="mt-2 text-sm leading-6 text-slate-600">{answer}</p>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="mt-10 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    <h2 className="text-2xl font-black text-slate-900">Billing, cancellation, and legal</h2>
                    <div className="mt-4 grid gap-4 md:grid-cols-3">
                        {[
                            ["Paid-only beta", "English Operator Beta uses USD operator pricing with no free tier and no 6-month plan."],
                            ["3-day trial", "A payment method is required. Unless canceled before the trial ends, the selected plan starts automatically."],
                            ["Cancel Subscription", "There is no downgrade-to-free flow. If canceled, the account becomes inactive unless the operator subscribes again."],
                        ].map(([title, text]) => (
                            <div key={title} className="rounded-xl bg-slate-50 p-4">
                                <p className="text-sm font-black text-slate-900">{title}</p>
                                <p className="mt-2 text-sm leading-6 text-slate-600">{text}</p>
                            </div>
                        ))}
                    </div>
                    <p className="mt-5 text-sm leading-6 text-slate-600">
                        USD prices are tax-exclusive. Tax collection is not enabled for the initial English Operator Beta unless otherwise required. Subscription fees are generally non-refundable unless required by law or separately agreed in writing.
                    </p>
                    <p className="mt-3 text-sm leading-6 text-slate-600">
                        The Japanese Terms of Service, Privacy Policy, and Specified Commercial Transactions disclosure are authoritative. English legal pages explain the main terms, privacy handling, and commercial basics for English-language operators.
                    </p>
                    <div className="mt-4 flex flex-wrap gap-2">
                        <a href={ENGLISH_BETA_LEGAL_SUMMARY_URL} target="_blank" rel="noopener noreferrer" className="inline-flex rounded-lg bg-slate-900 px-4 py-2 text-sm font-black text-white hover:bg-slate-800">Legal overview</a>
                        <a href={ENGLISH_BETA_TERMS_URL} target="_blank" rel="noopener noreferrer" className="inline-flex rounded-lg border border-slate-300 px-4 py-2 text-sm font-black text-slate-700 hover:bg-slate-50">Terms of Service</a>
                        <a href={ENGLISH_BETA_PRIVACY_URL} target="_blank" rel="noopener noreferrer" className="inline-flex rounded-lg border border-slate-300 px-4 py-2 text-sm font-black text-slate-700 hover:bg-slate-50">Privacy Policy</a>
                        <a href={ENGLISH_BETA_SCTA_URL} target="_blank" rel="noopener noreferrer" className="inline-flex rounded-lg border border-slate-300 px-4 py-2 text-sm font-black text-slate-700 hover:bg-slate-50">Commercial disclosure</a>
                    </div>
                </div>

                <div id="contact-form" className="mt-10 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
                    <h2 className="text-2xl font-black text-slate-900">Contact support</h2>
                    <p className="mt-2 text-sm text-slate-600">Send a support request for English beta onboarding, billing, cancellation, privacy, execution wording, or account questions.</p>
                    <form onSubmit={handleFormSubmit} className="mt-6 space-y-4">
                        <div>
                            <label htmlFor="inquiry-type" className="block text-sm font-bold text-slate-700">Inquiry type</label>
                            <select
                                id="inquiry-type"
                                name="inquiry-type"
                                value={inquiryType}
                                onChange={(e) => setInquiryType(e.target.value)}
                                className="mt-1 block w-full rounded-md border border-slate-300 p-3 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            >
                                <option value="English beta support">English beta support</option>
                                <option value="Execution workflow question">Execution workflow question</option>
                                <option value="Billing or account question">Billing or account question</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div>
                            <label htmlFor="subject" className="block text-sm font-bold text-slate-700">Subject</label>
                            <input
                                type="text"
                                name="subject"
                                id="subject"
                                value={subject}
                                onChange={(e) => setSubject(e.target.value)}
                                className="mt-1 block w-full rounded-md border border-slate-300 p-3 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            />
                        </div>
                        <div>
                            <label htmlFor="message" className="block text-sm font-bold text-slate-700">Message</label>
                            <textarea
                                id="message"
                                name="message"
                                rows="6"
                                required
                                className="mt-1 block w-full rounded-md border border-slate-300 p-3 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                            />
                        </div>
                        <div className="text-right">
                            <button type="submit" disabled={isSubmitting} className="rounded-lg bg-indigo-600 px-6 py-3 font-bold text-white shadow-lg hover:bg-indigo-700 disabled:bg-gray-400">
                                {isSubmitting ? "Sending..." : "Send support request"}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

function HelpPage() {
    const { user } = useOutletContext();
    const isEnglishBeta = isEnglishOperatorMode();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [inquiryType, setInquiryType] = useState(isEnglishBeta ? 'English beta support' : '機能に関するご要望');
    const [subject, setSubject] = useState(''); // ★★★ 新規追加: 件名用のstate

    // ★★★ 新規追加: 問い合わせ種別に応じて件名を自動入力する副作用
    useEffect(() => {
        switch (inquiryType) {
            case '代理店パートナーについて':
                setSubject('代理店パートナーに関する問い合わせ');
                break;
            case 'フォーム解析・品質改善パートナー参加希望':
                setSubject('フォーム解析・品質改善パートナー参加希望');
                break;
            case 'ご解約について':
                setSubject(''); // 解約時は件名をクリア
                break;
            default:
                // それ以外の時は件名を変更しない（ユーザーが入力した内容を保持）
                break;
        }
    }, [inquiryType]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (!user) {
            alert(isEnglishBeta ? 'User information was not found. Please log in again and retry.' : 'ユーザー情報が見つかりません。お手数ですが、再度ログインしてからお試しください。');
            setIsSubmitting(false);
            return;
        }

        const formData = new FormData(e.target);
        const payload = {
            inquiryType: formData.get('inquiry-type'),
            subject: subject, // ★★★ 修正: stateから件名を取得
            message: formData.get('message'),
            user: user
        };

        if (!payload.message) {
            alert(isEnglishBeta ? 'Please enter your support message.' : 'お問い合わせ内容を入力してください。');
            setIsSubmitting(false);
            return;
        }

        try {
            const response = await fetch(`${API_URL}/api/help-inquiry`, {
                method: 'POST',
                headers: { // ★ 2. 認証ヘッダーを追加
                    'Content-Type': 'application/json',
                    ...getAuthHeader() 
                },
                body: JSON.stringify(payload)
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || 'サーバーエラーが発生しました。');
            }
            
            alert(isEnglishBeta ? 'Support request sent.' : result.message);
            e.target.reset();
            setInquiryType(isEnglishBeta ? 'English beta support' : '機能に関するご要望'); 
            setSubject(''); // ★★★ 新規追加: 送信後に件名もリセット

        } catch (error) {
            console.error('お問い合わせの送信に失敗しました:', error);
            alert(`${isEnglishBeta ? "Error" : "エラー"}: ${error.message}`);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isEnglishBeta) {
        return (
            <EnglishOperatorHelpSurface
                inquiryType={inquiryType}
                setInquiryType={setInquiryType}
                subject={subject}
                setSubject={setSubject}
                isSubmitting={isSubmitting}
                handleFormSubmit={handleFormSubmit}
            />
        );
    }

    return (
        <div className="p-4 md:p-8 bg-gray-50 min-h-full">
            <div className="container mx-auto px-4 sm:px-6 max-w-5xl">
                <div className="text-center">
                     <h1 className="text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
                        ヘルプ & サポート
                    </h1>
                    <p className="mt-4 text-lg text-slate-600">
                        操作方法の確認や、困ったときはこちらをご覧ください。
                    </p>
                </div>

                <div className="mt-16 space-y-12">
                    
                    <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg border border-gray-200">
                        <div className="flex items-center mb-6">
                            <VideoIcon />
                            <h2 className="text-2xl font-bold text-slate-800">チュートリアル動画</h2>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                            {tutorialVideos.map(video => (
                                <VideoCard key={video.id} videoId={video.id} title={video.title} description={video.description} />
                            ))}
                        </div>
                    </div>

                    <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg border border-gray-200">
                        <div className="flex items-center mb-6">
                            <LightbulbIcon />
                            <h2 className="text-2xl font-bold text-slate-800">成果を最大化するヒント</h2>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                           <div className="p-6 bg-slate-50 rounded-lg text-left border border-slate-200">
                                <div className="aspect-video mb-2">
                                    <iframe
                                        className="w-full h-full rounded-md"
                                        src="https://www.youtube.com/embed/TosKiYQoxaY"
                                        title="【Tips①】効果的な文面の作り方"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                                <h3 className="text-lg font-bold text-slate-800">【Tips①】効果的な文面の作り方</h3>
                                <p className="mt-2 text-sm text-slate-600">開封率と返信率を高めるための具体的な文面作成のヒントをご紹介します。</p>
                            </div>
                             <div className="p-6 bg-slate-50 rounded-lg text-left border border-slate-200">
                                <div className="aspect-video mb-2">
                                    <iframe
                                        className="w-full h-full rounded-md"
                                        src="https://www.youtube.com/embed/uDA08B2l0dE"
                                        title="【Tips②】アポ率を高めるLP作成"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                                <h3 className="text-lg font-bold text-slate-800">【Tips②】アポ率を高めるLP作成</h3>
                                <p className="mt-2 text-sm text-slate-600">送信先から問い合わせに繋げるためのランディングページ作成のコツを解説します。</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg border border-gray-200">
                         <h2 className="text-2xl font-bold text-slate-800 mb-6">各種資料</h2>
                         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <a href="https://drive.google.com/file/d/1dRs03It7SG9OAMxJUSwjqkK_X3o0PWow/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="block p-6 bg-slate-50 rounded-lg text-left hover:bg-slate-100 transition-colors border border-slate-200 hover:shadow-lg">
                                <div className="flex items-center">
                                    <ManualIcon />
                                    <h3 className="ml-4 text-lg font-bold text-slate-800">操作マニュアル</h3>
                                </div>
                                <p className="mt-2 text-sm text-slate-600">基本的な使い方から応用までを解説しています。</p>
                            </a>
                            <a href="https://drive.google.com/file/d/1heRUIU8XSAq-WYVWf5AfROhit7055H8d/view" target="_blank" rel="noopener noreferrer" className="block p-6 bg-slate-50 rounded-lg text-left hover:bg-slate-100 transition-colors border border-slate-200 hover:shadow-lg">
                                <div className="flex items-center">
                                    <AdviceIcon />
                                    <h3 className="ml-4 text-lg font-bold text-slate-800">ワンポイントアドバイス</h3>
                                </div>
                                <p className="mt-2 text-sm text-slate-600">より効果的に活用するためのヒント集です。</p>
                            </a>
                            <a href="https://drive.google.com/file/d/1bGS4D-RYAbe-AOupBCyveyIxq74P57fs/view" target="_blank" rel="noopener noreferrer" className="block p-6 bg-slate-50 rounded-lg text-left hover:bg-slate-100 transition-colors border border-slate-200 hover:shadow-lg">
                                <div className="flex items-center">
                                    <FaqIcon />
                                    <h3 className="ml-4 text-lg font-bold text-slate-800">よくある質問</h3>
                                </div>
                                <p className="mt-2 text-sm text-slate-600">お客様からよく寄せられる質問と回答集です。</p>
                            </a>
                         </div>
                    </div>
                    
                    {/* ★★★ ここからが新規追加セクションです ★★★ */}
                    <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg border border-gray-200">
                        <div className="flex items-center mb-6">
                           <PartnerProgramIcon />
                           <h2 className="text-2xl font-bold text-slate-800">🤝 Sales Breaker パートナープログラムのご案内</h2>
                        </div>
                         <p className="text-slate-600 mb-8">
                            Sales Breakerでは、サービスの品質向上と普及にご協力いただけるパートナー様を募集しています。ご協力いただいたパートナー様には、特別な報酬や特典をご用意しております。
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                            {/* --- 代理店パートナー --- */}
                            <div className="p-6 bg-slate-50 rounded-lg border border-slate-200 flex flex-col">
                                <div className="flex items-center mb-4">
                                    <PartnershipIcon />
                                    <h3 className="ml-4 text-xl font-bold text-slate-800">代理店パートナー</h3>
                                </div>
                                <p className="text-sm text-slate-600 flex-grow">貴社のクライアント様にSales Breakerをご紹介いただくプログラムです。ご紹介いただいたクライアント様が有料プランをご契約されると、契約額に応じた報酬をお支払いいたします。</p>
                                <div className="mt-6">
                                    <p className="text-xs text-slate-500 mb-1 font-semibold">こんな方におすすめ：</p>
                                    <p className="text-xs text-slate-600">Web制作会社様、マーケティング支援会社様、多くのクライアントを抱えるコンサルタント様など。</p>
                                </div>
                                <div className="mt-6">
                                    <a href="#contact-form" onClick={() => setInquiryType('代理店パートナーについて')} className="font-semibold text-indigo-600 hover:text-indigo-800 transition-colors">
                                        詳細はこちらからお問い合わせください &rarr;
                                    </a>
                                </div>
                            </div>
                            {/* --- フォーム解析・品質改善パートナー --- */}
                            <div className="p-6 bg-slate-50 rounded-lg border border-slate-200 flex flex-col">
                                <div className="flex items-center mb-4">
                                    <BrainIcon />
                                    <h3 className="ml-4 text-xl font-bold text-slate-800">フォーム解析・品質改善パートナー</h3>
                                </div>
                                <p className="text-sm text-slate-600 flex-grow">フォーム仕様により送信できなかった際に、正しい入力箇所や確認結果を共有いただくプログラムです。ご協力いただいた内容は、フォーム解析精度と送信可否判定の品質維持・改善に利用します。</p>
                                <div className="mt-6">
                                     <p className="text-xs text-slate-500 mb-2 font-semibold">特典：</p>
                                     <ul className="space-y-2 text-sm">
                                        <li className="flex items-start"><span className="text-indigo-500 font-bold mr-2">1.</span> 貢献度ポイントの付与</li>
                                        <li className="flex items-start"><span className="text-indigo-500 font-bold mr-2">2.</span> <span className="bg-yellow-200 text-yellow-800 font-bold px-2 py-0.5 rounded-md">最大毎月2万円割引！</span> 特別料金プランのご提供</li>
                                     </ul>
                                     <p className="text-xs text-slate-500 mt-2">※貢献度ポイントが一定数に達したパートナー様は、割引価格の料金プランをご利用いただけます。</p>
                                </div>
                                <div className="mt-6">
                                     <p className="text-sm text-slate-600">「AI育成キュー」メニューからご参加いただけます。<br/>(メニューが表示されない場合は、下記フォームより参加希望をご連絡ください)</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* --- AIコンシェルジュ セクション --- */}
                    <div className="bg-gradient-to-br from-slate-900 to-indigo-900 p-8 sm:p-10 rounded-2xl shadow-xl border border-slate-800 text-center relative overflow-hidden">
                        {/* 装飾用の背景ボケ */}
                        <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-indigo-500/10 rounded-full blur-3xl"></div>
                        
                        <div className="relative z-10">
                            <div className="inline-block bg-indigo-600 text-white text-[10px] font-black px-3 py-1 rounded-full mb-6 uppercase tracking-[0.2em]">
                                AI Concierge
                            </div>
                            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">AIコンシェルジュに相談する</h2>
                            <p className="text-indigo-200 text-sm sm:text-base max-w-2xl mx-auto mb-10 leading-relaxed">
                                操作方法や活用戦略をAIが即座に回答します。<br />
                                Sales Breakerの仕様を参照して回答しますので、お気軽にご質問ください。
                            </p>
                            
                            <div className="flex flex-col sm:flex-row justify-center gap-4">
                                <a 
                                    href="https://gemini.google.com/gem/1j-8Dan1UK1m45ykojO9VJ8BNuqU2Yom8?usp=sharing" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="flex items-center justify-center space-x-3 bg-white hover:bg-indigo-50 text-slate-900 font-bold py-4 px-8 rounded-xl transition-all transform hover:scale-105 shadow-lg"
                                >
                                    <svg className="w-6 h-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.606 22.015c.108.136.269.22.443.232.02.001.04.001.06 0a.56.56 0 0 0 .444-.232c3.08-3.864 5.253-5.753 8.784-8.86a.56.56 0 0 0 .045-.815c-3.111-3.535-4.996-5.706-8.829-8.793a.56.56 0 0 0-.853.045c-3.08 3.864-5.253 5.753-8.784 8.86a.56.56 0 0 0-.045.815c3.111 3.535 4.996 5.706 8.829 8.793l-.094-.047Z" fill="#4285F4"/>
                                        <path d="M19.16 7.424a.403.403 0 0 0 .323.167.4.4 0 0 0 .32-.167c1.47-1.844 2.507-2.744 4.189-4.225a.4.4 0 0 0 .022-.584C22.532.936 21.631-.098 19.802-.572a.4.4 0 0 0-.61.032c-1.47 1.844-2.507 2.744-4.189 4.225a.4.4 0 0 0-.022.584c1.482 1.684 2.383 2.718 4.212 3.19l-.033-.035Z" fill="#FBBC05"/>
                                    </svg>
                                    <span>Gemini で質問する</span>
                                </a>

                                <a 
                                    href="https://chatgpt.com/g/g-698e6fd5d6cc819188ff7c5048efd455-salesbreakerji-ben-maniyuaru" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className="flex items-center justify-center space-x-3 bg-slate-800 hover:bg-slate-700 text-white font-bold py-4 px-8 rounded-xl transition-all transform hover:scale-105 shadow-lg border border-slate-600"
                                >
                                    <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M22.2819 9.8211a5.9847 5.9847 0 0 0-.5153-4.9082 6.0462 6.0462 0 0 0-4.4471-3.1243 6.0274 6.0274 0 0 0-5.0677 1.4444 6.0223 6.0223 0 0 0-4.388-1.4444 6.0481 6.0481 0 0 0-4.4461 3.1243 5.9847 5.9847 0 0 0-.5153 4.9082 6.0213 6.0213 0 0 0 1.4444 4.388 5.9847 5.9847 0 0 0 .5153 4.9082 6.0462 6.0462 0 0 0 4.4471 3.1243 6.0274 6.0274 0 0 0 5.0677-1.4444 6.0223 6.0223 0 0 0 4.388 1.4444 6.0481 6.0481 0 0 0 4.4461-3.1243 5.9847 5.9847 0 0 0 .5153-4.9082 6.0213 6.0213 0 0 0-1.4444-4.388Zm-10.2732 9.503-5.13-2.9618V10.45l5.13 2.9618Zm-1.1016-8.1902-5.13-2.9618L11 2.9618l5.13 2.9618Zm6.2318 5.2284-5.13 2.9618V13.4118l5.13-2.9618Z"/></svg>
                                    <span>GPTs で質問する</span>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div id="contact-form" className="bg-white p-6 sm:p-8 rounded-2xl shadow-lg border border-gray-200">
                        <h2 className="text-2xl font-bold text-slate-800 mb-2">フォームでのお問い合わせ</h2>
                        <p className="text-slate-600 mb-6">機能改善のご要望や、不具合のご報告に関するご連絡はこちらからお送りください。</p>
                        
                        <form onSubmit={handleFormSubmit}>
                            <div className="space-y-4">
                                <div>
                                    <label htmlFor="inquiry-type" className="block text-sm font-medium text-slate-700">お問い合わせ種別</label>
                                    <select 
                                        id="inquiry-type" 
                                        name="inquiry-type" 
                                        value={inquiryType}
                                        onChange={(e) => setInquiryType(e.target.value)}
                                        className="mt-1 block w-full p-3 border border-slate-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                                    >
                                        <option value="機能に関するご要望">機能に関するご要望</option>
                                        <option value="不具合のご報告">不具合のご報告</option>
                                        <option value="代理店パートナーについて">代理店パートナーについて</option>
                                        <option value="フォーム解析・品質改善パートナー参加希望">フォーム解析・品質改善パートナー参加希望</option>
                                        <option value="ご解約について">ご解約について</option>
                                        <option value="その他">その他</option>
                                    </select>
                                </div>

                                {inquiryType === 'ご解約について' && (
                                    <div className="p-4 bg-blue-50 border-l-4 border-blue-400 text-blue-800">
                                        <p className="font-bold">ご解約は無料プランへの移行となります。</p>
                                        <p className="text-sm mt-1">アカウント管理ページの「プラン変更」から無料プランをご選択ください。アカウントやデータは保持されたまま、料金の請求が停止されます。</p>
                                    </div>
                                )}

                                <div>
                                    <label htmlFor="subject" className="block text-sm font-medium text-slate-700">件名</label>
                                    <input 
                                        type="text" 
                                        name="subject" 
                                        id="subject" 
                                        value={subject}
                                        onChange={(e) => setSubject(e.target.value)}
                                        disabled={inquiryType === 'ご解約について'}
                                        className="mt-1 block w-full p-3 border border-slate-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-gray-100" />
                                </div>
                                <div>
                                    <label htmlFor="message" className="block text-sm font-medium text-slate-700">内容</label>
                                    <textarea 
                                        id="message" 
                                        name="message" 
                                        rows="6" 
                                        required 
                                        disabled={inquiryType === 'ご解約について'}
                                        className="mt-1 block w-full p-3 border border-slate-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 disabled:bg-gray-100"
                                    ></textarea>
                                </div>
                            </div>
                            <div className="mt-6 text-right">
                                <button 
                                    type="submit" 
                                    disabled={isSubmitting || inquiryType === 'ご解約について'}
                                    className="bg-indigo-600 text-white font-bold py-3 px-8 rounded-lg hover:bg-indigo-700 transition-all transform hover:scale-105 shadow-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
                                >
                                    {isSubmitting ? '送信中...' : '送信する'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HelpPage;
